export const CREATE_DUMPER = "CREATE_DUMPER";
export const RETRIEVE_DUMPERS = "RETRIEVE_DUMPERS";
export const UPDATE_DUMPER = "UPDATE_DUMPER";
export const DELETE_DUMPER = "DELETE_DUMPER";
export const DELETE_ALL_DUMPERS = "DELETE_ALL_DUMPERS";

